module.exports = __webpack_public_path__ + "img/sold_out.d11c6f8a.svg";